import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RdxContextStore } from './rdx-context.store';
import { RdxContextType } from './rdx-context-type.enum';
import { SessionRepository } from '../session';
import { UsersService } from '../user';
import { User } from '@frontend-site/shared/data';

@Injectable({
    providedIn: 'root'
})
export class RdxResolver  {
    constructor(private rdxContextStore: RdxContextStore, private sessionStore: SessionRepository, private usersService: UsersService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<[User[], User[]] | null> {
        const { companyId } = route.params;
        if (!!companyId && this.sessionStore.applicationConfig) {
            let companyAsNumber = Number(companyId);
            this.rdxContextStore.updateContext(companyAsNumber, RdxContextType.COMPANY, this.sessionStore.applicationConfig);
            return this.usersService.loadCompanyUsers(companyAsNumber);
        }
        return of(null);
    }
}
